module.exports = __webpack_public_path__ + "static/media/MuseoSansBlack.d403436e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansBlack/MuseoSansBlack.woff
// module id = 634
// module chunks = 0